import { INucDropdownItem } from '@relayter/rubber-duck';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { INucTableItem } from '../interfaces/table-item.interface';
import { ENotificationDestination, ENotificationType } from './notification.types';
import { RoleModel } from './role.model';
import { SessionModel } from './session.model';
import { UserTeamModel } from './user-team.model';

export class NotificationPreferenceModel {
    @autoserialize type: ENotificationType;
    @autoserialize options: ENotificationDestination[];
}

export class UserPreferencesModel {
    @autoserializeAs(NotificationPreferenceModel) notifications: NotificationPreferenceModel[];
}

abstract class BaseUserModel implements INucDropdownItem, INucTableItem {
    @autoserialize public _id: string;
    @autoserialize public email: string;
    @autoserialize public fullName: string;
    @autoserializeAs(SessionModel) public lastSession: SessionModel;
    @autoserializeAs(UserPreferencesModel) public preferences: UserPreferencesModel;

    /**
     * INucDropdownItem implementation
     * @returns {string}
     */
    public getValue(): string {
        return this._id;
    }

    /**
     * INucDropdownItem implementation
     * @returns {string}
     */
    public getTitle(): string {
        return this.fullName;
    }
}

@inheritSerialization(BaseUserModel)
export class UserModel extends BaseUserModel {
    @autoserializeAs(RoleModel, 'permissionGroups') public roles: RoleModel[] = [];
    @autoserialize public permissions: string[] = [];
}

@inheritSerialization(BaseUserModel)
export class UpdateUserModel extends BaseUserModel {}

@inheritSerialization(UserModel)
export class UserDetailModel extends UserModel {
    @autoserialize public acceptPolicy: boolean;
    @autoserialize public acceptTracking: boolean;
    @autoserialize public userHash: string;
    @autoserializeAs(UserTeamModel) public team: UserTeamModel;
}
